import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { gridView, listView } from '../library/Svgs';
import Downshift from 'downshift';
import {
  Label,
  Menu,
  ControllerButton,
  Input,
  Item,
  ArrowIcon,
  XIcon,
  css,
} from './shared'

const PipelineFilter = (props) => {
  const {
    stages, currentStage, setView, view, portfolios
  } = props;


  return (
    <div className="pipeline-filter">
      <div className="container">
        <div className="pipeline-filters-list">
        {currentStage != "closed-investments" &&
          Object.keys(stages).map(stage => (
            <Link
            key={`${stages[stage].slug}__link`}
            href={`/${stages[stage].slug}`}
            to={`/${stages[stage].slug}`}
            className={
              currentStage === stages[stage].slug || currentStage === 'all' ? 'active' : ''
            }
            dangerouslySetInnerHTML={{__html: stages[stage].title}}
            >
            </Link>
          ))
        }
        </div>
        <div className="filter-by-portfolio-dropdown">
          <Downshift 
          onChange={selection =>
            props.onSelectPortfolio(selection)
          }
          portfolios={portfolios}
          itemToString={item => (item ? item.title : '')}
          >
            {({
              getInputProps,
              getToggleButtonProps,
              getItemProps,
              isOpen,
              clearSelection,
              selectedItem,
              highlightedIndex,
            }) => (
              <div>

                <div className="filter-by-portfolio-dropdown__container">
            <Input
                {...getInputProps({
                  isOpen,
                  placeholder: 'Filter By Portfolio',
                })}
              />
                {selectedItem ? (
                    <ControllerButton
                      onClick={clearSelection}
                      aria-label="clear selection"
                    >
                      <XIcon />
                    </ControllerButton>
                  ) : (
                    <ControllerButton {...getToggleButtonProps()}>
                      <ArrowIcon isOpen={isOpen} />
                    </ControllerButton>
                  )}
            </div>
            <div className="dropdown" {...css({position: 'relative'})}>
              {!isOpen ? null : (
                <Menu {...portfolios}>
                  {props.portfolios.map((item, index) => (
                    <Item
                      key={item.id}
                      {...getItemProps({
                        item,
                        index,
                        isActive: highlightedIndex === index,
                        isSelected: selectedItem === item,
                      })}
                    >
                      {item.title}
                    </Item>
                  ))}
                </Menu>
              )}
            </div>
          </div>
            )}
          </Downshift>
        </div>
      </div>
    </div>
  );
};

PipelineFilter.propTypes = {
  stages: PropTypes.shape({}).isRequired,
  currentStage: PropTypes.string.isRequired,
  portfolios: PropTypes.array.isRequired,
};

export default PipelineFilter;
